export const environment = {
  production: true,
  index: 'https://app.hvllcronicare.sanidadmadrid.org/',
  endpoint: location.origin,
  authServer: 'https://login.hvllcronicare.sanidadmadrid.org',
  authRealm: 'cronicare',
  authClientId: 'cronicare-front',
  showChatbot: false
};

